module.exports = __webpack_public_path__ + "static/media/info.054d20a7.png";